import { combineReducers } from '@reduxjs/toolkit';

import { withRouterQuery } from './injectQuery';
import address from './address';
import app from './app';
import comparables from './comparables';
import marketing from './marketing';
import { marketTrends, unfilteredMarketTrends } from './marketTrends';
import { medianRentByBedroom } from './medianRentByBedroom';
import search from './search';
import topMarkets from './topMarkets';
import ui from './ui';
import user from './user';

const rootReducer = (routerReducer) =>
  combineReducers({
    app,
    address,
    comparables,
    marketing,
    marketTrends,
    medianRentByBedroom,
    search,
    topMarkets,
    ui,
    unfilteredMarketTrends,
    user,
    router: withRouterQuery(routerReducer),
  });

export default rootReducer;
